export const T = {
  en_GB: {
    add: "Add",
    addNote: "Note",
    addCall: "Call",
    addMeeting: "Meeting",
    uploadFile: "Upload file",
    uploading: "Uploading…",
    none: "Nothing added yet. Add a note, call or meeting, or drop files here to upload.",
    dropHere: "Drop files to upload",
    failedUpload: "Upload failed",
    columnDate: "Date",
    columnType: "Type",
    columnTopic: "Topic",
    columnSummary: "Summary",
    columnBy: "By",
    columnActions: "Actions",
    note: "Note",
    call: "Call",
    meeting: "Meeting",
    file: "File",
    noContent: "No content",
    deleteTitle: "Delete",
    deleteConfirmation: (title: string) => `Delete "${title}"? This cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    showSummary: "Show summary",
    retry: "Retry transcription",
    noteWord: "note",
    callWord: "call",
    meetingWord: "meeting",
  },
  nb_NO: {
    add: "Legg til",
    addNote: "Notat",
    addCall: "Samtale",
    addMeeting: "Møte",
    uploadFile: "Last opp fil",
    uploading: "Laster opp…",
    none: "Ingenting lagt til enda. Legg til et notat, en samtale eller et møte, eller slipp filer her for å laste opp.",
    dropHere: "Slipp filer for å laste opp",
    failedUpload: "Opplasting feilet",
    columnDate: "Dato",
    columnType: "Type",
    columnTopic: "Tema",
    columnSummary: "Sammendrag",
    columnBy: "Av",
    columnActions: "Handlinger",
    note: "Notat",
    call: "Samtale",
    meeting: "Møte",
    file: "Fil",
    noContent: "Ingen innhold",
    deleteTitle: "Slett",
    deleteConfirmation: (title: string) => `Slette "${title}"? Dette kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    showSummary: "Vis sammendrag",
    retry: "Prøv transkripsjon på nytt",
    noteWord: "notat",
    callWord: "samtale",
    meetingWord: "møte",
  },
} as const;
